// extracted by mini-css-extract-plugin
export default {"scrollarea":"Dashboard_scrollarea__PqEvq","wrapper":"Dashboard_wrapper__w7rk0","group":"Dashboard_group__+Fmxg"};